import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Resulttrip() {
  return (
    <section className="result_trip p-100 text_trip">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              The <span>Results</span>
            </h2>
            <p>
              The outcome was better than expected; multiple platform modules
              work seamlessly with several third-party integrations and data
              sharing, including a completely secure payment processing system
              and features offering users the authority to use the platform and
              meet their goals.
            </p>
            <p>
              iOS, Android, and Web platforms provide the intended audience with
              all the convenience they need to transport their horses to their
              desired destinations around the globe. We delivered a complete
              digital solution with the potential to scale in multiple parts of
              the world.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="result_img">
              <StaticImage
                src="../../../images/case-studies/equi-trip/results_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={700}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resulttrip;
